import { UPDATE_DP_SOA_ACTIVITIES } from 'src/DigitalProtocolModule/constants'

export const initialSoa = {
  soaAddedLabs: [],
  soaAddedExamination: [],
  soaAddedProcedures: [],
  soaAddedQuestionnaires: [],
  soaAddedStudyProcedures: [],
  soaVisits: [],
  soaWeeks: [],
  soaDays: [],
  soaPeriod_data: [],
  scenarios: [],
  soaWeekWindow: [],
  soaDayWindow: [],
}

const dpSoaReducer = (state = initialSoa, action) => {
  switch (action.type) {
    case UPDATE_DP_SOA_ACTIVITIES:
      state = {
        ...state,
        ...action.payload,
      }
      break
    default:
  }
  return state
}
export default dpSoaReducer
